import { render } from "./GlobalLoader.vue?vue&type=template&id=38b57266"
import script from "./GlobalLoader.vue?vue&type=script&lang=js"
export * from "./GlobalLoader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__